import React from "react";
import "./Header.css"; // Importamos los estilos

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        <h1>Pokemon EVs</h1>
      </div>
    </header>
  );
};

export default Header;
